
import { Component, OnInit } from '@angular/core';
import { Spinkit, SpinnerVisibilityService } from 'ng-http-loader'; // to manually toggle visibility
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {Observable, of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { AppNavigationService } from './app-navigation.service';
import { Router } from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {LifeGoalRestService} from 'life-goal-rest';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  spinkit = Spinkit;
  router: Router;
  mode = new FormControl('over');
  canGoNext = false;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  planId: string;
  appName: string;
  apiVersion: string;

  constructor(
    private breakpointObserver: BreakpointObserver,
    public navigationService: AppNavigationService,
    router: Router,
    private cookieService: CookieService,
    private lifeGoalRestService: LifeGoalRestService
  ) {
    // this.test();
    this.router = router;
  }

  ngOnInit() {
    this.fetchCookieValues();
  }

  fetchCookieValues() {
    this.planId = this.cookieService.get('plan') ? JSON.parse(this.cookieService.get('plan')).id : '';
    this.appName = this.cookieService.get('appType') ? JSON.parse(this.cookieService.get('appType')).appName : '';
    this.apiVersion = this.cookieService.get('api_version');
  }
  test() {
    this.cookieService.set('api_version', 'v1');
    this.cookieService.set('plan', JSON.stringify({id: '6735954b8b5349421df17980'}));
    this.cookieService.set('appType', JSON.stringify({appName: 'retirement'}));
    sessionStorage.setItem('mmih_auth_token',
      // tslint:disable-next-line: max-line-length
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOnsibWFpbCI6ImpvaG4ud2lja0BtZXRyb3BvbGl0YW4uY28uemEiLCJkaXNwbGF5TmFtZSI6IkpvaG4gV2ljayIsImVtcGxveWVlTnVtYmVyIjoiMDk5MDAwMCIsInNBTUFjY291bnROYW1lIjoiSm9XaWNrIiwiZ2l2ZW5OYW1lIjoiSm9obiIsImFjY2Vzc0dyb3VwcyI6WyJzZWN1cml0eS5hY2Nlc3Muc2VhcmNoQ2xpZW50Iiwic2VjdXJpdHkuYWNjZXNzLnNlYXJjaGF1ZGl0bG9ncyIsInNlY3VyaXR5LmFjY2Vzcy5tZXRodWIuY2lzIiwic2VjdXJpdHkuYWNjZXNzLmF1ZGl0Vmlld2VyLmNsaWVudENyaXRpY2FsVXBkYXRlcyIsInNlY3VyaXR5LmFjY2Vzcy5tZXRodWIucG9jMSJdLCJlbXBsb3llZUdVSUQiOiIiLCJjbiI6IkpvV2ljayIsImNvbXBlbnRlbmN5IjpbeyJjb21wZXRlbmN5TGlzdFN0YXR1c1Jlc3BvbnNlIjoiQWN0aXZlIiwiY29tcGV0ZW5jeVJvbGVTdGF0dXNSZXNwb25zZSI6IkFjdGl2ZSIsImNvbXBldGVuY3lSb2xlc1Jlc3BvbnNlIjp7InByaW1hcnlSb2xlIjoiRklOQU5DSUFMIEFEVklTRVIifSwiY29tcGV0ZW5jeUxpc3RSZXNwb25zZSI6WyJNZXRyb3BvbGl0YW4gRnVuZXJhbCBQbGFuIChNRlApIiwiTWV0cm9wb2xpdGFuIEhlYWx0aENhcmUgQ2FzaEJhY2sgUGxhbiAoTUhDUCkiLCJNZXRyb3BvbGl0YW4gUmV0aXJlbWVudCBTYXZpbmdzIFBsYW4gU1RQIiwiTWV0cm9wb2xpdGFuIEluY29tZSBhbmQgTGlmZSBDb3ZlciBQbGFuIFNUUCIsIk1ldHJvcG9saXRhbiBGbGV4aWJsZSBJbmNvbWUgUGxhbiBTVFAiLCJNZXRyb3BvbGl0YW4gVGVybSBJbmNvbWUgUGxhbiBTVFAiLCJNZXRyb3BvbGl0YW4gR3VhcmFudGVlZCBJbmNvbWUgUGxhbiBTVFAiLCJNZXRyb3BvbGl0YW4gRW5kb3dtZW50IFNhdmluZ3MgUGxhbiBTVFAiLCJNZXRyb3BvbGl0YW4gUGVhY2Utb2YtTWluZCBGdW5lcmFsIFBsYW4iLCJOZXcgTWV0cm9wb2xpdGFuIFNhdmluZ3MgUGxhbiAtIFNlcnZpY2luZyAtIFBsYW4gaW5mb3JtYXRpb24gW3ZpZXcgb25seV0iLCJOZXcgTWV0cm9wb2xpdGFuIFNhdmluZ3MgUGxhbiAtIFNhbGVzLVRpZXIxIiwiTWV0cm9wb2xpdGFuIExpZmUgQ292ZXIgUGxhbiAoTUxDUCkiLCJNZXRyb3BvbGl0YW4gUkFGIC0gU2FsZXMtVGllcjEiLCJOZXcgTWV0cm9wb2xpdGFuIFJldGlyZW1lbnQgUGxhbiAtIFNhbGVzLVRpZXIxIiwiUmV0aXJlbWVudCBsaWZlIGdvYWwgYXNzZXNzbWVudHMiLCJNZXRyb3BvbGl0YW4gUmV0aXJlbWVudCBTYXZpbmdzIFBsYW4iLCJNZXRyb3BvbGl0YW4gQ3JlZGl0IExpZmUgUGxhbiIsIk1ldHJvcG9saXRhbiBQZXJzb25hbCBMb2FuIiwiTWV0cm9wb2xpdGFuIE1vbmV5IE1hcmtldCBTYXZpbmdzIFBsYW4iLCJNZXRyb3BvbGl0YW4gVGF4LUZyZWUgU2F2aW5ncyBQbGFuIl19XX0sImlhdCI6MTczMTU3MjIzNiwiZXhwIjoxNzMxNjU4NjM2fQ.LpkvtGJSMEJN_Glof-_O5nmwy1NfRovboeLmVU2Ode8');
  }

  redirectToSearch() {
    this.navigationService.redirectToSearch();
  }

  redirectToWellnessWheel() {
    this.navigationService.redirectToWellnessWheel();
  }

  navigate(action: string) {
    this.navigationService.navigate(action);
  }
}
